import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    boxSizing: "border-box",
  },
  viewerComponent: {
    backgroundColor: theme.palette.primary.main,
    borderRadius: "30px",
    height: "77%",
    minHeight: "500px",
    minWidth: "900px",
    width: "90%",
    position: "absolute",
    // top: matchHeight ? "10%" : "4%",
    top: "4%",
    left: "5%",
    zIndex: "1205",
    outline: "none",
  },
  statusDiv: {
    display: "flex",
    alignItems: "center",
    gap: "6px",
    backgroundColor: theme.palette.secondary.light,
    borderRadius: "10px",
    padding: "5px 10px",
    marginRight: "8px",
  },
  imageIconColor: {
    color: theme.palette.text.primary,
    fontSize: "21px",
    fontWeight: "bold",
  },
  leftButtonContainer: {
    position: "absolute",
    color: "green",
    top: "50%",
    left: "-50px",
  },
  rightButtonContainer: {
    position: "absolute",
    color: "green",
    top: "50%",
    right: "-50px",
  },
  leftOrRightButton: {
    padding: "0px",
    height: "100px",
    width: "50px",
    minWidth: "0px",
  },
  toolsContainer: {
    height: "72px",
    width: "100%",
    display: "flex",
    gap: "40px",
    fontSize: "14px",
    justifyContent: "space-between",
    padding: "10px 30px 0px 30px",
  },
  breadcrumb: {
    display: "flex",
    alignItems: "center",
    gap: "5px",
  },
  statusAndOtherToggler: {
    display: "flex",
    position: "absolute",
    right: "29.5%",
    alignItems: "center",
  },
  annotationButton: {
    margin: "10px",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
  },
  iconStyle: {
    height: "30px",
    width: "30px",
  },
  compareButton: {
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
  },
  commentsOrTaskToggler: {
    height: "100%",
    display: "flex",
    alignItems: "center",
  },
  closeButton: {
    display: "flex",
    alignItems: "center",
    gap: "5px",
    cursor: "pointer",
  },
  modelViewerDiv: {
    width: "100%",
    position: "relative",
    height: "98%",
  },
  allowHrdChange: {
    position: "absolute",
    bottom: "0.1%",
    paddingLeft: "20px",
    width: "100%",
    height: "40px",
    boxShadow: "0 -10px 5px 1px rgba(0,0,0,0.45)",
    background: "rgba(0,0,0,0.45)",
    borderRadius: " 0 0 20px 20px",
  },
  notAllowed: {
    display: "none",
    position: "absolute",
    marginTop: "-50px",
    marginLeft: "20px",
  },
  imageDiv: {
    display: "flex",
    justifyContent: "space-between",
    marginRight: "10px",
    cursor: "pointer",
  },
  imageStyle: {
    height: "19.14px",
    width: "29.78px",
    marginTop: "2px",
  },
  downloadOption: {
    backgroundColor: "#1B1D28",
    padding: "5px",
    cursor: "pointer",
  },
  player: {
    height: "100%",
    width: "100%",
  },
  noFile: {
    display: "flex",
    justifyContent: "center",
  },
  versionSelector: {
    height: "120px",
    backgroundColor: "",
    minWidth: "900px",
    width: "100%",
  },
  reminderModal: {
    width: "172px",
    padding: "4px 8px",
    borderRadius: "8px",
    backgroundColor: theme.palette.secondary.main,
    textAlign: "center",
    fontFamily: "Poppins",
  },
  boldText: {
    fontWeight: "600",
  },
  innerPop: {
    width: "20px",
    height: "22px",
    clipPath: "polygon(100% 50%, 0 0, 0 100%)",
    backgroundColor: theme.palette.secondary.main,
    marginLeft: "-3px",
  },
  noDataContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "98%",
    position: "relative",
  },
  noDataContainerText: {
    position: "absolute",
    color: theme.palette.primary.main,
    width: "320px",
    height: "110px",
    left: "40%",
    top: "30%",
  },
}));

export default useStyles;
